import { useState } from 'react'
import { MUTUAL_FUND_DETAIL_IMAGE_URL } from '../../../constants'
import { trackEvent } from '../../../utils/appBridge'
import { getNumberInParantheses } from '../../../utils/mutualFundDetail'
import MFAccordion from '../../ui-components/MFAccordion'
import { useMetaDataContext } from '../../../state-management/contexts/MetaDataContext'
import { EventNames } from '../../../types/misc.types'
import FundManager from './FundManager'

export const FundManagers = () => {
  const [isFundManagersAccordionExpanded, setIsFundManagersAccordionExpanded] = useState(false)
  const { data, isin } = useMetaDataContext()
  return (
    <MFAccordion
      icon={`${MUTUAL_FUND_DETAIL_IMAGE_URL}/fund-managers-icon.svg`}
      title={`Fund Managers ${getNumberInParantheses(data?.fundManagers?.length)}`}
      isExpanded={isFundManagersAccordionExpanded}
      onAccordionClick={() =>
        setIsFundManagersAccordionExpanded((isAboutFundAccordionExpandedPrev) => {
          trackEvent({
            eventName: EventNames.UserClicked,
            payload: {
              eventId: 'Fund_managers',
              responseName: isAboutFundAccordionExpandedPrev ? 'Collapse' : 'Expand',
              screenType: 'MF_L2',
              fundName: isin
            }
          })
          return !isAboutFundAccordionExpandedPrev
        })
      }
      isBorderTop={true}
    >
      <div className='flex flex-col gap-[16px] pt-2 pb-[16px] pl-[1px] w-full'>
        {data?.fundManagers?.map((datum, idx) => {
          return (
            <FundManager
              key={`${idx.toString()}-${datum?.name}`}
              name={datum?.name}
              date={datum?.date}
              linkedinUrl={datum?.linkedIn}
              twitterUrl={datum?.twitter}
              isBorderBottom={idx !== data?.fundManagers?.length - 1}
              isNew={datum?.newFundManager}
            />
          )
        })}
      </div>
    </MFAccordion>
  )
}
